import { Component, type ErrorInfo, type ReactNode } from "react";
import { AlertTriangle } from "lucide-react";
import { isDevelopmentRuntime, reportTechnicalError } from "../lib/errors";
import { Button, Card } from "./ui";

export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    reportTechnicalError(error, "ui.errorBoundary");
    if (isDevelopmentRuntime()) console.error("[ui.componentStack]", info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="flex min-h-screen items-center justify-center bg-slate-50 p-6"><Card className="max-w-lg p-8 text-center"><div className="mx-auto mb-4 flex size-12 items-center justify-center rounded-2xl bg-rose-50 text-rose-600"><AlertTriangle /></div><h1 className="text-xl font-semibold text-slate-900">页面暂时无法显示</h1><p className="mt-2 text-sm leading-6 text-slate-500">系统已隐藏底层连接信息。请刷新重试；若问题持续，请将发生时间告知管理员。</p><Button className="mt-6" onClick={() => window.location.reload()}>刷新页面</Button></Card></main>;
  }
}
